import Schema, { array } from 'AppReact/schema';

export default {
  fileName: Schema('string', 'primitive', { defaultValue: '' }),
  csvData: Schema(array('string'), 'array', { defaultValue: [[]] }),
  isOpen: Schema('boolean', 'primitive', { defaultValue: false }),
  containerRef: Schema({}, 'object', { defaultValue: null }),
  fetchingPDF: Schema('boolean', 'primitive', { defaultValue: false }),
  showSubscribe: Schema('boolean', 'primitive-nullable', { defaultValue: false }),
  hidePdf: Schema('boolean', 'primitive-nullable', { defaultValue: false }),
  subscribeComingSoon: Schema('boolean', 'primitive-nullable', { defaultValue: false }),
}
